<template>
  <v-container v-if="currentUser && currentUser.state !== 'STAFF'">
    <v-app-bar app color="secondary" dark dense>
      <v-toolbar-title>
        {{
          $t("dashboard.currentAuditPeriod", {
            year: currentUser.currentAuditPeriod ? currentUser.currentAuditPeriod.year : "",
          })
        }}
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <v-chip
        v-if="currentUser.currentAuditPeriod && auditPeriodIsClosed(currentUser.currentAuditPeriod)"
        color="green"
        dark
      >
        {{
          $t("dashboard.auditPeriod.closed", {
            date: new Date(currentUser.currentAuditPeriod.closedAt).toLocaleString(undefined, {
              timeZone: "CET",
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
            }),
          })
        }}
      </v-chip>
    </v-app-bar>

    <template v-if="mustUpdateProfile">
      <v-alert type="info">
        {{ $t("dashboard.updateProfile") }}
      </v-alert>

      <ProfileForm />
    </template>

    <v-row v-if="!mustUpdateProfile && currentUser.currentAuditPeriod">
      <v-col cols="12" md="6">
        <DeadLines />
      </v-col>

      <v-col cols="12" md="6">
        <AuditPeriodList />
      </v-col>
    </v-row>

    <template v-if="!mustUpdateProfile && currentUser.currentAuditPeriod">
      <v-row v-if="mayGenerateInterview">
        <v-col cols="12">
          <InterviewInfo :audit-period="currentUser.currentAuditPeriod" />
        </v-col>
      </v-row>

      <v-row v-if="currentUser.currentAuditPeriod.mayChooseInterview">
        <v-col cols="12">
          <ChooseInterview :auditPeriod="currentUser.currentAuditPeriod" />
        </v-col>
      </v-row>

      <AuditPeriod :audit-period="currentUser.currentAuditPeriod" />
    </template>

    <v-row v-if="!mustUpdateProfile && !currentUser.currentAuditPeriod">
      <v-col cols="12">
        <NoCurrentAuditPeriodInfo />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import AuditPeriod from "@/components/User/AuditPeriod";
import AuditPeriodList from "@/components/User/AuditPeriodList";
import HomeQuery from "@/gql/queries/HomeQuery.gql";
import mayGenerateInterview from "@fng/common/mayGenerateInterview";
import auditPeriodIsClosed from "@fng/common/auditPeriodIsClosed";
import ProfileForm from "@/components/User/ProfileForm";
import DeadLines from "@/components/User/DeadLines";
import ChooseInterview from "@/components/User/ChooseInterview.vue";
import InterviewInfo from "@/components/User/InterviewInfo.vue";
import NoCurrentAuditPeriodInfo from "@/components/User/NoCurrentAuditPeriodInfo.vue";

export default {
  components: {
    AuditPeriod,
    AuditPeriodList,
    ProfileForm,
    DeadLines,
    ChooseInterview,
    NoCurrentAuditPeriodInfo,
    InterviewInfo,
  },

  data() {
    return {
      currentUser: null,
    };
  },

  computed: {
    mayGenerateInterview() {
      return this.currentUser.currentAuditPeriod && mayGenerateInterview(this.currentUser.currentAuditPeriod.funds);
    },

    mustUpdateProfile() {
      if (!this.currentUser.profileUpdatedAt) return true;

      const current = new Date();
      const deadline = new Date();

      deadline.setMonth(0);
      deadline.setDate(1);
      deadline.setHours(0);
      deadline.setMinutes(0);
      deadline.setSeconds(0);

      const updated = new Date(this.currentUser.profileUpdatedAt);

      return current > deadline && updated < deadline;
    },
  },

  apollo: {
    currentUser: {
      query: HomeQuery,
      fetchPolicy: "cache-and-network",
    },
  },

  methods: {
    auditPeriodIsClosed,
  },
};
</script>
